import React, { Component } from 'react';
import axios from "axios";
import logoreg from "../demoImg.jpg";
import Path from "./config";
export class PhotoSample extends Component {
    constructor(props) {
        super(props)
        this.state = {
            payment_id: ""
        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            phoneId: localStorage.getItem("phoneId")
        })


    }
    NextForm = () => {
        this.props.history.push(`/FormProfile/UploadDoc`);
    }
    render() {
        //console.log ("userId",this.state.userId );
        //console.log ("paymenId",this.state.payment_id );

        return (
            <>
                <div className="container-fluid text-success text-center m-2 font-weight-normal">
                    Sample Photo

                </div>
                <div className="container-fluid">

                    <div className="row justify-content-md-center my-2 ">
                        <p>  टीप :-  आपण अपलोड केलेला फोटो हा सोबत दिलेल्या नमुन्या प्रमाणेच फक्त क्लोज अप
                            आणी योग्य क्वालिटी चा असावा फोटो हे या पद्धतीने नसल्यास फोटो सुचित फोटो खराब च
                            प्रिंट होऊ शकतो आणी जास्त खराब असलेला फोटो सुचित प्रिंट होणार नाही याची विशेष नोंद घ्यावी.</p>
                        <div className="col-md-12 text-center">
                            <img src={logoreg} /> <br></br><br></br>
                            <button class="btn btn-primary" type="button" onClick={() => this.NextForm()}>Back</button>

                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default PhotoSample
